import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import React from "react";
import DevTools from "mobx-react-devtools";
import Layout from "./layout/index";
import { init } from "./user/index";
import { isDev } from "./reusable/utils";
import SpreadTable from "./spreadsheet/table";
import Studio from "./studio/index";
import { StreamlabsPopup, sendCode } from "./spreadsheet/providers/streamlabs";

export default props => {
  return (
    <Router>
      <div id="app-root" style={{ width: "100%", height: "100%" }}>
        <Switch>
          <Route
            exact
            path="/"
            render={({ match, history }) => {
              init();
              return <Layout />;
            }}
          />
          <Route
            exact
            path="/live/:userId"
            render={({ match }) => {
              init(match.params.userId);
              return <Layout live />;
            }}
          />
          <Route
            exact
            path="/live/:userId/:sceneId"
            render={({ match }) => {
              init(match.params.userId, match.params.sceneId);
              return <Layout live />;
            }}
          />
          <Route
            exact
            path="/spy/:userId"
            render={({ match }) => {
              init(match.params.userId, undefined, true);
              return <Layout />;
            }}
          />
          <Route
            exact
            path="/database"
            render={({ match }) => {
              init();
              return (
                <div className="spreadtable-standalone">
                  <SpreadTable />
                </div>
              );
            }}
          />
          <Route
            exact
            path="/studio"
            render={({ match }) => {
              init();
              return (
                <div className="spreadtable-standalone">
                  <Studio />;
                </div>
              );
            }}
          />
          <Route
            exact
            path="/connect/streamlabs/:token"
            render={({ match, location }) => {
              sendCode(match.params.token);
              return <StreamlabsPopup />;
            }}
          />
          <Route
            exact
            path="/:userId/:sceneId"
            render={({ match }) => {
              init(match.params.userId, match.params.sceneId);
              return <Layout />;
            }}
          />
        </Switch>
        {isDev && <DevTools />}
      </div>
    </Router>
  );
};



// WEBPACK FOOTER //
// ./src/router.js